import { render, staticRenderFns } from "./hospital_contract.vue?vue&type=template&id=6eff1e85&scoped=true"
import script from "./hospital_contract.vue?vue&type=script&lang=js"
export * from "./hospital_contract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eff1e85",
  null
  
)

export default component.exports